import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EmailPreference } from '@demind-inc/core';

import { accountApi } from '../api';

interface UseUpdateEmailPrefParams {
  preferenceId: string;
  preferences: Partial<EmailPreference>;
}

export const useUpdateEmailPref = () => {
  const queryClient = useQueryClient();

  const updateEmailPrefMutation = useMutation({
    mutationFn: ({ preferenceId, preferences }: UseUpdateEmailPrefParams) => {
      return accountApi.updateEmailPreference(preferenceId, preferences).then((data) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.preference'] });
    },
  });

  return {
    updateEmailPref: updateEmailPrefMutation.mutateAsync,
    ...updateEmailPrefMutation,
  };
};
